import { defineStore } from 'pinia';
import { shallowRef } from 'vue';

type StructuredMergeHandler = (payload: Record<string, unknown>) => void | Promise<void>;

type HandlerRegistration = {
  draftKey: string;
  token: number;
  fn: StructuredMergeHandler;
};

/** 创建项目页注册：在 ProjectCreate 对话中收到新的 structured_result 时合并到左侧表单 */
export const useProjectCreateStructuredMergeStore = defineStore('projectCreateStructuredMerge', () => {
  const handler = shallowRef<HandlerRegistration | null>(null);
  let nextToken = 0;

  function registerMergeHandler(draftKey: string, fn: StructuredMergeHandler): number {
    const token = ++nextToken;
    handler.value = { draftKey: String(draftKey || '').trim(), token, fn };
    return token;
  }

  function clearMergeHandler(token?: number) {
    if (token == null || handler.value?.token === token) {
      handler.value = null;
    }
  }

  async function notifyStructuredMerge(
    payload: Record<string, unknown> | null | undefined,
    draftKey = '',
  ): Promise<boolean> {
    if (!payload || typeof payload !== 'object') return false;
    const active = handler.value;
    const targetDraftKey = String(draftKey || '').trim();
    if (!active || (targetDraftKey && active.draftKey !== targetDraftKey)) return false;
    try {
      await active.fn(payload);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  return { registerMergeHandler, clearMergeHandler, notifyStructuredMerge };
});
